
const envConfig = {
    API_URL: process.env.REACT_APP_API_URL || 'https://blueresilience.app/profishblue_api',
};

export default envConfig;
